module.exports = __webpack_public_path__ + "static/media/pomodoroTimer.6b273eac.png";